import Grid from '@mui/material/Grid';
import styles from 'assets/css/Hypo.module.css';
import {digitsEnToFa} from "persian-tools2";
function maxValueHypo(arr,active) {
    let maxValue = Number.MIN_VALUE;
    for (let i = 0; i < arr.length; i++) {
        if (active === 'total'){
            if (arr[i].allCount > maxValue) {
                maxValue = arr[i].allCount;
            }
        }else{
            if (arr[i].level2Count > maxValue) {
                maxValue = arr[i].level2Count;
            }
        }
    }
    return maxValue<10?10:maxValue;
}

export const HypoChart = ({ active, HypoglycemiaChartData }) => {
  const maxValueChart = maxValueHypo(HypoglycemiaChartData,active);
  return (
    <Grid container display="flex" alignItems="end" flexDirection="row-reverse">
      {HypoglycemiaChartData.map((item, index) => {
        const value = active === 'total' ? item?.allCount : item?.level2Count;
        return (
          <Grid className={styles.Child} xs={1.5}>
            <p
              className={styles.numberLevel}
              style={{
                height: '20px',
                visibility:
                  value >= maxValueChart && value !== 0 ? 'visible' : 'hidden',
              }}
            >
              {value}
            </p>
            {index !== 0 ? (
              <div
                className={styles.FlexContainer}
                style={{backgroundColor: '#F5F5F5',borderRadius:'6px',padding:'6px'}}>
                <div
                  style={{
                    height: isNaN((value * 100) / maxValueChart)
                      ? 0
                      : (value * 100) / maxValueChart + '%',
                  }}
                  className={`${styles.FlexChild}`}
                />
                {value < maxValueChart && value !== 0 && (
                  <p className={styles.numberLevel}>{value}</p>
                )}
              </div>
            ) : (
              <div className={styles.FlexContainerLabel}>
                <span className={styles.chartLabel}>{item.allCount}</span>
              </div>
            )}

            <p className={index === 0 ? styles.titleHour : styles.hourHypo}>
              {digitsEnToFa(item.hours)}
            </p>
          </Grid>
        );
      })}
    </Grid>
  );
};
